import React from "react";
import { Tooltip } from "@euroland/react-tooltip";
import { TOOL_TEMPLATE } from "../../constant/common";
import { useCompanySettings, useTemplateSetting } from "../../hooks/useCompanySettings";
import { useInstrument } from "../../hooks/useInstruments";
import { useAmountInvested, useDividendData } from "../../hooks/useTrades";
import i18n from "../../locale/i18n";
import Icon from "../ui/Icon";
import Label from "../ui/Label";

const appSettings = window.appSettings;

const DownloadExcelButton = () => {
  const template = useTemplateSetting();
  const settings = useCompanySettings();
  const [{ query }] = useAmountInvested();
  const [{ selectedInstrument }] = useInstrument();
  const isPreviewParam = appSettings.isPreview ? "&isPreview" : "";

  const downloadLink =
    `download/excel/?lang=${appSettings.language || "en-gb"}&companyCode=${
      appSettings.companyCode
    }&selectedinstrumentid=${selectedInstrument.instrumentId ?? ""}&v=${
      appSettings.companyCodeVersion ?? ""
    }&fromDate=${query.startDate}&toDate=${query.endDate}&currency=${query.currency || ""}` + isPreviewParam;
  const dividendData = useDividendData();

  if (!settings.enableExcelDownload || !dividendData?.datas?.length) {
    return null;
  }
  return (
    <>
      {template === TOOL_TEMPLATE.victor ? (
        <a className="download-button" rel="noreferrer" target="_blank" href={downloadLink}>
          <Icon name="excel" className="download-button--icon" />
          <Label className="download-button--label">{i18n.translate("excel")}</Label>
        </a>
      ) : (
        <div className="download-excel__quadrata">
          <Tooltip label={i18n.translate("downloadExcel")}>
            <a className="download-button" rel="noreferrer" target="_blank" href={downloadLink}>
              <Icon name="excel" className="download-button--icon" />
            </a>
          </Tooltip>
        </div>
      )}
    </>
  );
};

export default DownloadExcelButton;
